import { DateTime } from 'luxon';
import { forwardRef } from 'react';
import cc from 'classcat';

interface ISingleDay {
    day: DateTime;
    selected?: boolean;
    onClick?: (date: DateTime) => void;
    displayToday?: boolean;
    isSelectable?: boolean;
    isDayOff: boolean;
}

export const SingleDay = forwardRef<HTMLButtonElement, ISingleDay>(
    ({ day, selected, onClick, displayToday = true, isSelectable = true, isDayOff }, ref) => {
        const dayOff = isDayOff;

        return (
            <button
                ref={ref}
                onClick={() => onClick && onClick(day)}
                className={cc([
                    'single-day',
                    { 'single-day--active': selected },
                    { 'single-day--today': displayToday && DateTime.now().startOf('day').equals(day) },
                    { 'single-day--weekend': day.weekday === 6 || day.weekday === 7 },
                    { 'single-day--not-selectable': !isSelectable },
                    { 'single-day--day-off': dayOff },
                ])}
                data-tooltip={dayOff ? 'Overlapping leave request' : undefined}
            >
                <h3>{day.weekdayShort}</h3>
                <p className={cc(['paragraph-3', 'single-day__date', { 'single-day__date--day-off': dayOff }])}>
                    <span className={cc(['single-day__date-wrapper', { 'has-tooltip': dayOff }])}>
                        {day.toFormat('dd.MM.')}
                        {dayOff && <span className="single-day__date-tooltip">Overlapping leave request</span>}
                    </span>
                </p>
            </button>
        );
    }
);
